export const PREPAID_HOW_IT_WORKS_STEPS = [
  {
    key: "buy-before-submission",
    title: "Buy tests before submission",
    description: "Purchase tests in bundles to fund your sample submissions in advance.",
  },
  {
    key: "deducted-by-category",
    title: "Tests are deducted by test category",
    description: "Each test is used from its category. Keep all categories funded to avoid delays.",
  },
  {
    key: "return-credits",
    title: "Removed tests may return credits",
    description: "Tests can be returned if they are removed before processing begins.",
  },
];

export const TEST_TIERS = ["Basic", "Advanced", "Specialty"];

export const PREPAID_OFFERS = [
  {
    key: "shipping-label-willis",
    icon: "receipt",
    description: "Get a free FedEx shipping label with the purchase of $500 in tests.",
    expiresInDays: 2,
  },
  {
    key: "swabbing-willis",
    icon: "flask",
    description:
      "Get $50 worth of swabbing materials with the purchase of $500 in test credits.",
    expiresInDays: 2,
  },
  {
    key: "pickup-willis",
    icon: "truck",
    description: "Get free pickup for one month with orders over $2,500.",
    expiresInDays: 2,
  },
  {
    key: "shipping-label-combi",
    icon: "receipt",
    description: "Get a free FedEx shipping label with the purchase of $500 in tests.",
    expiresInDays: 2,
    location: "Pack Produce, Combi Center",
  },
  {
    key: "swabbing-combi",
    icon: "flask",
    description:
      "Get $50 worth of swabbing materials with the purchase of $500 in test credits.",
    expiresInDays: 2,
    location: "Pack Produce, Combi Center",
  },
];

export const PLAN_BUILDER_OFFERS = [
  {
    key: "free-pickup",
    icon: "truck",
    description: "Get free pickup for one month with orders over $2,500.",
  },
  {
    key: "swabbing-materials",
    icon: "flask",
    description:
      "Get $50 worth of swabbing materials with the purchase of $500 in test credits.",
  },
  {
    key: "shipping-label",
    icon: "receipt",
    description: "Get a free FedEx shipping label with the purchase of $500 in tests.",
  },
  {
    key: "loyalty-points",
    icon: "coin",
    description: "1 point earned for every $100 spent. 1 point = $1 in test credits.",
  },
];

/** Maps /usage/credits/ usage_category_code → UI category + tier */
export const USAGE_CREDITS_CATEGORY_MAP = {
  MICRO_BASIC: { categoryKey: "microbiology", categoryName: "Microbiology", tierName: "Basic" },
  MICRO_ADVANCED: { categoryKey: "microbiology", categoryName: "Microbiology", tierName: "Advanced" },
  MICRO_SPECIALTY: { categoryKey: "microbiology", categoryName: "Microbiology", tierName: "Specialty" },
  CHEM_BASIC: { categoryKey: "chemistry", categoryName: "Chemistry", tierName: "Basic" },
  CHEM_ADVANCED: { categoryKey: "chemistry", categoryName: "Chemistry", tierName: "Advanced" },
  CHEM_SPECIALTY: { categoryKey: "chemistry", categoryName: "Chemistry", tierName: "Specialty" },
};

export const USAGE_CREDITS_CATEGORY_META = {
  microbiology: {
    key: "microbiology",
    name: "Microbiology",
    tierOrder: ["Basic", "Advanced", "Specialty"],
  },
  chemistry: {
    key: "chemistry",
    name: "Chemistry",
    tierOrder: ["Basic", "Advanced", "Specialty"],
  },
};

/** Mock locations for multi-location Usage Metrics admin view. */
export const MULTI_LOCATION_OPTIONS = [
  { key: "all", label: "All locations" },
  { key: "willis", label: "Pack Produce, Willis Tower" },
  { key: "combi", label: "Pack Produce, Combi Center" },
  { key: "chicago", label: "Pack Produce, Chicago" },
  { key: "north", label: "Pack Produce, North Loop" },
  { key: "west", label: "Pack Produce, West Loop" },
  { key: "south", label: "Pack Produce, South Side" },
  { key: "oak", label: "Pack Produce, Oak Park" },
];

export const USAGE_METRICS_PATH = "/myaccount/usage-metrics";
const USAGE_METRICS_BUILD_PLAN_PARAM = "build-plan";
export const PLAN_BUILDER_PREFILL_CREDITS_KEY = "esv.usageMetrics.planBuilderPrefillCredits";
export const START_TOPUP_POOL_ALERT_SHOWN_KEY = "esv.usageMetrics.startTopupPoolAlertShown";
export const START_TOPUP_POOL_ALERT_PENDING_KEY = "esv.usageMetrics.startTopupPoolAlertPending";

export const getUsageMetricsBuildPlanPath = () => (
  `${USAGE_METRICS_PATH}?${USAGE_METRICS_BUILD_PLAN_PARAM}=true`
);

export const hasUsageMetricsBuildPlanParam = (search = "") => {
  const params = new URLSearchParams(search);
  return params.get(USAGE_METRICS_BUILD_PLAN_PARAM) === "true";
};
